import React from 'react';
import BlueprintArraySettingItem from './blueprint-array-setting-item';
import Text from '../../global/text/text';
import { ITemplateDetailsSettings, TArrayFields } from '../../../api/blueprints/blueprint-details.types';
import BlueprintStringSettingItem from './blueprint-string-setting-item';
import { MEETING_NOTES, arrayFieldsMapper } from '../../../constants/blueprint-details.mapper.constants';
import { TObject } from '../../../infrastructure/type-extensions';
import { formatBlueprintSettingValue } from '../../../infrastructure/utils/blueprint-setting-value.formatter';

const settingsAsRichText = [ MEETING_NOTES ];

export interface IBlueprintItemDetailsProps {
    settingItem: ITemplateDetailsSettings;
    paddingLeft: number;
}

const BlueprintItemDetails = ({
    settingItem,
    paddingLeft,
}: IBlueprintItemDetailsProps) => {
    const { settingValue: mainSettingValue } = settingItem;

    return (
        <div className='m-top-25px blueprint-details--settings-item'>
            <Text
                tag='div'
                className='blueprint-details--settings-item__title'
                message={ settingItem.title }
            />
            {
                mainSettingValue.map(setting => {
                    const isSettingArray = Array.isArray(setting.settingValue);
                    const isRichText = settingsAsRichText.includes(setting.title);
                    const isCusttomSetting = setting.custom;

                    let settingMapperValueKeys: string[];
                    let settingMapperValues: Record<string, string>;

                    if (isSettingArray && !isCusttomSetting) {
                        settingMapperValueKeys = Object.keys(arrayFieldsMapper[setting.title]);
                        settingMapperValues = arrayFieldsMapper[setting.title];
                    }

                    return <div className={`p-left-${paddingLeft}px ${isSettingArray || isRichText ? '' : 'flex'}`} key={setting.title} >
                        {isCusttomSetting
                            ? <setting.component key={setting.title} values={setting.settingValue as TObject<string>[]} />
                            : (
                                <>
                                    <Text
                                        className='blueprint-details--settings-item__title'
                                        message={setting.title}
                                    />
                                    :
                                    {isSettingArray
                                        ? (setting.settingValue as TArrayFields[]).map((sValue: TArrayFields, index: number) => {
                                            return (
                                                <BlueprintArraySettingItem
                                                    key={index}
                                                    paddingLeft={paddingLeft * 2}
                                                    settingMapperValueKeys={settingMapperValueKeys}
                                                    settingMapperValues={settingMapperValues}
                                                    settingValue={sValue}
                                                />
                                            );
                                        })
                                        : <BlueprintStringSettingItem
                                            isRichText={isRichText}
                                            textValue={formatBlueprintSettingValue(
                                                setting.title,
                                                setting.settingValue
                                            )}
                                        />
                                    }
                                </>
                            )}

                    </div>
                        ;
                })
            }
        </div>
    );
};

export default BlueprintItemDetails;
